import { Countries, CodeToCountry } from './countries.js';
import { DialCodes, DialCodeToCountryCode } from './dialcodes.js';
import { UnitedStates, Canada } from './states.js';

var Datasets = {
    COUNTRIES: Countries,
    CodeToCountry: CodeToCountry,
    DIAL_CODES: DialCodes,
    DialCodeToCountryCode: DialCodeToCountryCode,
    USA_STATES: UnitedStates,
    CANADA_STATES: Canada,
};

export { Datasets };
